import { useEffect, useState } from "react";
import { useRoomBorrowingStore } from "@/store/room_borrowing/roomBorrowingStore";
import { useRoomBorrowingNext } from "../RoomBorrowing";
import { List, ListItem } from "@/components/ui/list/List";
import { IRoomLocation } from "@/models/room/RoomLocation";
import SkeletonList from "@/components/ui/skeleton/SkeletonList";
import RoomLocationService from "@/lib/services/room/RoomLocationService";
import { UserFacingError } from "@/models/helper/UserFacingError";
import { useToast } from "@/lib/hooks/useToast";

const ChooseLocation = () => {
  const { toast } = useToast();
  const [locations, setLocations] = useState<IRoomLocation[]>([]);
  const [loading, setLoading] = useState(false);
  const roomBorrowingStore = useRoomBorrowingStore();
  const { setRoomBorrowingNext } = useRoomBorrowingNext();

  const handleSelected = (loc: IRoomLocation) => {
    roomBorrowingStore.update("location", loc.id);
    roomBorrowingStore.update("room_type", -1);
  };

  useEffect(() => {
    const d = roomBorrowingStore.data.location;
    if (d !== undefined && d > 0) {
      setRoomBorrowingNext(true);
    } else {
      setRoomBorrowingNext(false);
    }
  }, [roomBorrowingStore.data.location, setRoomBorrowingNext]);

  useEffect(() => {
    let ignore = false;
    const fetchData = async () => {
      setLoading(true);
      try {
        const locations = await RoomLocationService.getBorrowingLocations();

        if (ignore === true) return;
        setLocations(locations);
      } catch (error) {
        if (error instanceof UserFacingError) {
          toast({ title: error.title, description: error.description });
        }
      }
      setLoading(false);
    };
    fetchData();

    return () => {
      ignore = true;
    };
  }, [toast]);

  return (
    <div className={`w-full`}>
      <List header="Choose one of Campus room location you want to borrow">
        {loading ? (
          <SkeletonList count={6} skeletonClassName="h-16" />
        ) : (
          <>
            {locations.length === 0 && <div>No Data</div>}
            {locations.map((location) => (
              <ListItem
                isSelected={location.id === roomBorrowingStore.data.location}
                key={location.id}
                onClick={() => handleSelected(location)}
              >
                {location.location}
              </ListItem>
            ))}
          </>
        )}
      </List>
    </div>
  );
};

export default ChooseLocation;
